export default __webpack_public_path__ + "07f618a128bee964e26edcaa069c5e78.png";